import { Badge, Card, LinkButton } from "@/components/ui";

export default function BillingSuccessPage() {
  return (
    <div className="mx-auto grid min-h-[70vh] max-w-xl place-items-center px-5 py-12">
      <Card className="w-full p-8 text-center">
        <Badge tone="success">Payment successful</Badge>
        <h1 className="mt-5 text-3xl font-semibold tracking-tight">
          Funds are on their way
        </h1>
        <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-muted">
          Stripe confirmed your payment. Your EasyShot cash balance is updated
          by the secure payment webhook, usually within a few seconds.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <LinkButton href="/studio/billing">View balance</LinkButton>
          <LinkButton href="/studio" variant="secondary">
            Create a video
          </LinkButton>
        </div>
      </Card>
    </div>
  );
}
